import { ca } from '@cian/analytics';

export function trackParentClick({
  realtyUserId,
  position,
  parentId,
  title,
  parentUrl,
}: {
  realtyUserId: number;
  position: number;
  parentId: number | undefined;
  title: string;
  parentUrl: string | undefined;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_cardjk',
    page: {
      extra: {
        is_specproject: true,
        to_object: parentId,
        object_type: 'JK',
        position: position + 1,
        hit_url: parentUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
